import React from "react";
import Header from "./Header";
import HeroSection from "./HeroSection";
import VisualSection from "./VisualSection";
import WhyUsSection from "./WhyUsSection";
import ProgramsSection from "./ProgramsSection";
import MethodologySection from "./MethodologySection";
import TestimonialsSection from "./TestimonialsSection";
import PricingSection from "./PricingSection";
import CTAFooter from "./CTAFooter";
import FloatingParticles from "./FloatingParticles";

const LandingPage = () => {
  return (
    <div className="landing-page">
      <FloatingParticles />
      <Header />
      <HeroSection />
      <VisualSection />
      <WhyUsSection />
      <ProgramsSection />
      <MethodologySection />
      <TestimonialsSection />
      <PricingSection />
      <CTAFooter />
    </div>
  );
};

export default LandingPage;